export function convertToSeconds(value: number | undefined, defaultValue: number): number {
  if (value && Number.isInteger(value)) {
    return value / 1000;
  }

  return defaultValue;
}

export const isFunction = (val: unknown): boolean => typeof val === 'function';

export function round(value: number, decimalPlaces = 2): number {
  const factor = Math.pow(10, decimalPlaces);

  return Math.round(value * factor) / factor;
}
